import angular from 'angular';
import reportPackageSummary from './reportPackageSummary';
import directive from './report-package-summaries.directive';
import controller from './report-package-summaries.controller';

export default angular
  .module('app.components.reports.packageReports.reportPackageSummaries', [reportPackageSummary])
  .directive('prReportPackageSummaries', directive)
  .controller('PRReportPackageSummariesController', controller).name;

console.log('app.components.reports.packageReports.reportPackageSummaries created');
